import { useInView } from 'react-intersection-observer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';

const ProjectCard = ({ title, description, slideDirection, image, highlights, skills, onCardClick }) => {
    const { ref, inView } = useInView({
        triggerOnce: false,
        threshold: 0.5,
    });

    const translateXValue = slideDirection === 'left' ? '-100px' : '100px';

    return (
        <Box
            ref={ref}
            onClick={() => onCardClick({ title, description, image, highlights, skills })}
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: slideDirection === 'left' ? 'row' : 'row-reverse' },
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 3,
                opacity: inView ? 1 : 0,
                transform: inView
                    ? 'translateX(0)'
                    : `translateX(${translateXValue})`,
                transition: 'all 0.8s ease-out',
                width: '100%',
                cursor: 'pointer',
            }}
        >
            <Card
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    color: 'white',
                    borderRadius: 3,
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.4)',
                    border: '1px solid white',
                    backdropFilter: 'blur(5px)',
                    width: { xs: '100%', sm: '250px' },
                    height: 'auto',
                    marginBottom: { xs: 2, sm: 0 },
                }}
            >
                <CardContent>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'white', marginBottom: 2 }}>
                        {title}
                    </Typography>
                    <Box
                        component="img"
                        src={image}
                        alt={`${title} image`}
                        sx={{
                            width: '100%',
                            height: '150px',
                            objectFit: 'cover',
                            borderRadius: 1,
                            marginBottom: 2
                        }}
                    />
                </CardContent>
            </Card>
            <Box
                sx={{
                    color: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    padding: 2,
                    borderRadius: 2,
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                    maxWidth: { xs: '100%', sm: 400 },
                    textAlign: 'left',
                }}
            >
                <Typography variant="body1" sx={{ color: '#B0BEC5', fontWeight: 'bold' }}>
                    {description}
                </Typography>

                {highlights && highlights.length > 0 && (
                    <Box component="ul" sx={{ paddingLeft: 2, color: '#B0BEC5' }}>
                        {highlights.map((highlight, index) => (
                            <Typography key={index} component="li" variant="body2" sx={{ marginBottom: 0.5 }}>
                                {highlight}
                            </Typography>
                        ))}
                    </Box>
                )}

                {skills && skills.length > 0 && (
                    <Box sx={{ marginTop: 2, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {skills.map((skill, index) => (
                            <Chip 
                                key={index} 
                                label={skill} 
                                sx={{
                                    backgroundColor: '#1E88E5',
                                    color: 'white',
                                    fontWeight: 'bold',
                                }} 
                            />
                        ))}
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ProjectCard;